import Card from "../../../Card/Card";
import QuantitySelector from '../../../FormComponents/QuantitySelector';
import { VossProductType } from '../../../../Constants/VOSS/vossProductType';
import { VossProductGroupType } from '../../../../Constants/VOSS/vossProductGroupType';
import { useTranslation } from 'react-i18next';

export function VossLicenseOptionsCard({ offer, selections, onUpdateLicense }) {
    const { t } = useTranslation();
    const tier = offer.tiers?.find(t => t.id === selections.tierId);
    const activeGroups = tier?.productGroups?.filter(g =>
        g.productGroupType === VossProductGroupType.Included ||
        (selections.optionalProductGroupIds ?? []).includes(g.id)
    ) ?? [];

    const licenses = selections.licenses ?? [];

    const licenseProducts = activeGroups.flatMap(g =>
        g.products
            .filter(p => p.type === VossProductType.License)
            .map(p => {
                const entry = licenses.find(l => l.productId === p.id);
                return {
                    productId: p.id,
                    groupName: g.name,
                    name: p.name,
                    quantity: entry?.quantity || 0,
                    initialQuantity: entry?.initialQuantity ?? 0,
                };
            })
    );

    return (
        <Card>
            <Card.Header>
                <Card.Header.Title>{t('vossLicenseOptionsCard.licenses')}</Card.Header.Title>
            </Card.Header>
            <Card.Content>
                {licenseProducts.length > 0 ? (
                    <fieldset className="d-flex flex-column gap-24 mb-0 px-0">
                        {licenseProducts.map((license, index) => (
                            <div key={license.productId}>
                                {index > 0 && <hr className="m-0 mb-24"/>}
                                <div className="d-flex justify-content-between align-items-center">
                                <h4 className="bold mb-0">{license.groupName} - {license.name}</h4>
                                <QuantitySelector
                                    key={`${license.productId}-${license.quantity}`}
                                    lowerThreshold={license.initialQuantity}
                                    value={license.quantity}
                                    onChange={(value) => onUpdateLicense(license.productId, value)}
                                />
                                </div>
                            </div>
                        ))}
                    </fieldset>
                ) : (
                    <em>{t('vossLicenseOptionsCard.noLicenseProducts')}</em>
                )}
            </Card.Content>
        </Card>
    );
}